import { createAction } from "~/utils/actions";

export default {
	...createAction("SETT_ANTALL_SIDER"),
	...createAction("RESET_ANTALL_SIDER"),
};
